import { useEffect, useState } from "react";
import Form from "../../../../../components/form/Form";
import { useHub, usePreferences, useStatuses } from "../../../../../core/Global";
import { toastSuccess } from "../../../../../components/base/Toast";
import Icon from "../../../../../components/base/Icon";
import FlexRow from "../../../../../components/base/FlexRow";
import ToggleSwitch from "../../../../../components/form/ToggleSwitch";



export default function TechStatusAccess() {

    const hub = useHub();
    const pref = usePreferences();
    const statuses = useStatuses();
    const [working, workingSet] = useState<boolean>(false);

    const [allowedStatuses, allowedStatusesSet] = useState<string[]>([])

    useEffect(() => {
        if (pref?.techsAllowedJobStatusIds) allowedStatusesSet(pref.techsAllowedJobStatusIds)
    }, [pref])


    return (
        <Form className="form"
            onSubmit={(e, callback) => {
                workingSet(true);
                hub.Post("/system/Settings/techallowedstatuses", allowedStatuses, res => {
                    if (res.success) {
                        toastSuccess("Technician allowed job statuses has been updated successfully!");
                    }
                    if (callback) callback(res);
                    workingSet(false);
                });
            }}>
            <div className="card mb-5">
                <div className="card-header border-0">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                            Allowed Job Statuses
                        </h3>
                    </div>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    : <>Update Preferences</>
                            }
                        </button>
                    </div>
                </div>
                <div className="card-body border-top px-9 pt-10 pb-10">

                    <div className="mb-2">
                        Define which job statuses are visible to technicians.
                    </div>

                    <FlexRow className="mb-10">
                        <Icon icon="info-circle" className="text-muted fs-8 me-2" />
                        <span className="fs-8 text-gray-600">
                            Only jobs assigned to them with these statuses will appear in their list.
                        </span>
                    </FlexRow>

                    <FlexRow column alignItems="start">
                        {
                            statuses.map(st =>
                                <div key={`st-${st.id}`} className="mb-5">
                                    <ToggleSwitch label={st.name} raw small
                                        checked={allowedStatuses.includes(st.id!)}
                                        onChange={e => {
                                            if (e) allowedStatusesSet(prev => [...prev, st.id!])
                                            else allowedStatusesSet(prev => prev.filter(item => item !== st.id!));
                                        }} />
                                </div>
                            )
                        }
                    </FlexRow>


                </div>
            </div>
        </Form>
    )
}